"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBillingFeesDto = instanceOfBillingFeesDto;
exports.BillingFeesDtoFromJSON = BillingFeesDtoFromJSON;
exports.BillingFeesDtoFromJSONTyped = BillingFeesDtoFromJSONTyped;
exports.BillingFeesDtoToJSON = BillingFeesDtoToJSON;
exports.BillingFeesDtoToJSONTyped = BillingFeesDtoToJSONTyped;
/**
 * Check if a given object implements the BillingFeesDto interface.
 */
function instanceOfBillingFeesDto(value) {
    if (!('employerFeePct' in value) || value['employerFeePct'] === undefined)
        return false;
    if (!('platformFeePct' in value) || value['platformFeePct'] === undefined)
        return false;
    return true;
}
function BillingFeesDtoFromJSON(json) {
    return BillingFeesDtoFromJSONTyped(json, false);
}
function BillingFeesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employerFeePct': json['employerFeePct'],
        'platformFeePct': json['platformFeePct'],
    };
}
function BillingFeesDtoToJSON(json) {
    return BillingFeesDtoToJSONTyped(json, false);
}
function BillingFeesDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'employerFeePct': value['employerFeePct'],
        'platformFeePct': value['platformFeePct'],
    };
}
//# sourceMappingURL=BillingFeesDto.js.map